export default __webpack_public_path__ + "static/quote-card-2-60e7da73c1be5c70ec10a70a0ea90c9d.png";